export default __webpack_public_path__ + "static/media/chairbg.8f6617ae.jpeg";